import PropTypes from 'prop-types'
import React from 'react'

import { Wrapper, DynamicImageStyled } from './styles'

const BHowFirstRussianBox = ({ path }) => (
  <Wrapper>
    <DynamicImageStyled
      image={`${path}/biome-flying-new`}
      imageType="png"
      imageSizes={{ xs: 420, md: 1000 }}
      fitOption="contain"
      alt={'Тест Микробиоты'}
    />
  </Wrapper>
)

BHowFirstRussianBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default BHowFirstRussianBox
